import { render, staticRenderFns } from "./modalReagendamentoExames.vue?vue&type=template&id=cbc1d95a&"
import script from "./modalReagendamentoExames.vue?vue&type=script&lang=js&"
export * from "./modalReagendamentoExames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports